var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_848_735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 4.75301L8.64634 6.27967L8.95967 7.01967L9.75967 7.08634L11.4063 7.22634L10.153 8.31301L9.54634 8.83967L9.72634 9.62634L10.0997 11.233L8.68634 10.3797L7.99967 9.95301L7.31301 10.3663L5.89967 11.2197L6.27301 9.61301L6.45301 8.82634L5.84634 8.29967L4.59301 7.21301L6.23967 7.07301L7.03967 7.00634L7.35301 6.26634L7.99967 4.75301ZM7.99967 1.33301L6.12634 5.75301L1.33301 6.15967L4.97301 9.31301L3.87967 13.9997L7.99967 11.513L12.1197 13.9997L11.0263 9.31301L14.6663 6.15967L9.87301 5.75301L7.99967 1.33301Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_848_735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlights);
export default __webpack_public_path__ + "static/media/highlights.a1d284bce6baaca317dc79070abedf60.svg";
export { ForwardRef as ReactComponent };